const Colors = {
  mainShadeOfRed: "#f93749",
  mainBlue: "#4D55E5",
  mainShadeOfSolitude: "#EDF0F7",
  mainCeruleanBlue: "#314ACE",
  mainShadeOfRuby1: "#E61567",
  mainShadeOfRuby2: "#CC115B",
  neutralShadesOfNero: "#222222",
  neutralShadesOfDimGray: "#717171",
  neutralShadesOfPinkSwan: "#B5B5B5",
  neutralShadesOfGainsboro: "#DDDDDD",
  neutralShadesOfWhisper: "#EDEDED",
  neutralShadesOfWhiteSmoke: "#F6F6F6",
  additionalShadesOfBitterSweet: "#FF6B6B",
  additionalShadesOfKellyGreen1: "#48C21E",
  additionalShadesOfKellyGreen2: "#37A512",
  gradientNeonBlue: "#4D55E5",
  gradientVioletRed: "#FD3483",
  suvaGrey: "#8F8F8F",
  white: "#ffffff",
  boxShadow: "rgba(34, 34, 34, 0.21)",
  errorColor: "#DB1A2D",
};
export default Colors;
